
<div class="row margin-top-15px margin-right-0px" >
  <div class="offset-md-2 col-md-8 S1 padding-right-0px background-white">
    <div class="card">

      <div class="card-header background-white pad1">
        <div class="row">
          <div class="col-md-3">
            <label class="title font-size-20px margin-top-0px margin-bottom-0px">Book Appointment</label>
          </div>
        </div>
      </div>

      <div class="card-header background-white pad1">
        <div class="row margin-bottom-8px">
          <div class="offset-md-1 col-md-2">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img1" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row a1">
              <label class="margin-bottom-0px f2">Dr.Sitharam</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">Cardiologist</label>
            </div>

          </div>
          <div class="col-md-3">
            <div class="row">
              <label class="margin-bottom-0px f2">Kalyani Nagar</label>
            </div>
            <div class="row">
              <label class="margin-bottom-0px">Bangalore Ã¢â‚¬â€œ 560 043</label>
            </div>
            <div class="row">
              <label class="margin-bottom-0px">Karnataka</label>
            </div>

          </div>
          <div class="col-md-3">
            <div class="row">
              <label class="margin-bottom-0px f2">Branch Contact</label>
            </div>
            <div class="row">
              <label class="margin-bottom-0px"><i class="fas fa-phone"></i> : 0877-224531</label>
            </div>
            <div class="row">
              <label class="margin-bottom-0px"><i class="fas fa-envelope"></i> : garbagudi&#64;healins.com</label>
            </div>

          </div>
        </div>


      </div>

      <div class="card-body background-white  padding-left-0px padding-top-0px">
        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px b2 margin-bottom-10px">

          <div class="row">
            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px c3">
              <div class="row">
                <div class="offset-md-3 col-md-9 padh1">

                  <div class="col-md-3">
                    <div class="row">
                      <label class="margin-bottom-0px f2">Appointment</label>
                    </div>
                    <div class="row">
                      <label class="margin-bottom-0px">24-May-2019</label>
                    </div>
                    <div class="row">
                      <label class="margin-bottom-5px">11:15 A.M</label>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="offset-md-3 col-md-9 margin-top-30px margin-bottom-30px">

              <div class="row">
                <label class="font-size-20px margin-bottom-5px margin-top-10">Patient Details</label>
              </div>
              <div class="row my-pro-form margin-t-form">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Name </label>
                    </div>
                    <div class="col-md-6">

                      <input type="text" class="form-control form-control-patient font-size-20px" placeholder="Name">


                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Phone Number </label>
                    </div>
                    <div class="col-md-6">

                      <input type="tel" class="form-control form-control-patient font-size-20px" mask="(000-000-0000)" placeholder="Phone Number">
                      <!--<small class="form-text text-danger"
                             *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->


                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Email </label>
                    </div>
                    <div class="col-md-6">

                      <input type="text" class="form-control form-control-patient font-size-20px" placeholder="Email">


                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Age </label>
                    </div>
                    <div class="col-md-6">

                      <input type="text" class="form-control form-control-patient font-size-20px" placeholder="Age">


                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Sex </label>
                    </div>
                    <div class="col-md-6">

                      <label>
                        <select class="form-control form-control-patient font-size-20px">
                          <option> </option>
                          <option>Male</option>
                          <option>Female</option>
                        </select>
                      </label>



                    </div>


                  </div>

                </div>
              </div>























            </div>



          </div>

        </div>
        <div class="row margin-top-15px margin-top-30px margin-bottom-30px">

          <div class="col-md-5">
            <button class="btn bs hover1 nav-link-hand font-size-16px width float-right"  type="button">Back</button>
          </div>
          <div class="col-md-5 padding-left-0px padding-right-24px">
            <button class="btn btn-primary hover1 nav-link-hand font-size-16px width float-right"  type="button">Proceed</button>
          </div>


        </div>
      </div>
    </div>
  </div>

</div>





